module.exports = __webpack_public_path__ + "static/media/FileDownload.bc6c5278.svg";